<template>
    <div>
        <div v-if="loading">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
        <div v-else>
            <app-form v-bind:parentObject="{
                data: this.formData,
                id: this.id,
                company: this.company,
                //searchnew: this.search,
                pageTitle: this.pageTitle,
                pageTitleValue: this.pageTitleValue,
                errMsg: this.errMsg,
                isEdit: this.isEdit,
            }" v-on:input="formData = $event" v-on:error="errorHandler" />

            <div v-if="isErr">
                <app-error v-bind:parentError="{
                    data: this.errMsg,
                    isErr: this.isErr,
                }" v-on:closeError="isErr = $event" />
            </div>
        </div>
    </div>
</template>

<script>
import ModerationRecordFormDetail from "../../../components/performance/moderationrecord/FormDetail";
import moment from 'moment';
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
    components: {
        "app-form": ModerationRecordFormDetail,
        "app-error": ErrorDialog,
    },

    data() {
        return {
            id: this.$route.params.id,
            //search: this.$route.params.search,
            company: this.$route.params.company,
            pageTitle: this.$t('pmmoderation.pmmoderationprocess'),
            pageTitleValue: "",
            formData: {
                id: null,
                pmassessmentrecordcode: null,
                pmassessmentrecorddesc: null,
                startdate: null,
                enddate: null,
                ratingid: null,
                stamp: null,
                userid: this.$store.getters.userId,
            },
            errMsg: "",
            isErr: false,
            loading: true,
            isEdit: false,
            isConfirm: false,
        };
    },

    methods: {
        errorHandler($event) {
            this.isErr = $event.isErr;
            this.errMsg = $event.errMsg;
        },
        
        async loadSelectedPmAsseRecordByID() {
            this.isErr = false;
            this.errMsg = "";

            try {
                const res = await this.$store.dispatch('get', { url: `/calculatedPmAsseById/${this.id}` });
                if (res.status === 200 && res.data.rec) {
                    this.formData = { ...res.data.rec };
                    if (this.formData.startdate) {
                        this.formData.startdate = moment(this.formData.startdate).format('YYYY-MM-DD');
                    }
                    if (this.formData.enddate) {
                        this.formData.enddate = moment(this.formData.enddate).format('YYYY-MM-DD');
                    }
                } else {
                    this.isErr = true;
                    console.error("data not found");
                    this.errMsg = "Record not found.";
                }
            } catch (err) {
                console.error("Error loading record:", err);
                this.isErr = true;
                this.errMsg = err.message || "Network Error";
            }
        },

    },

    async mounted() {
        try {
            await this.loadSelectedPmAsseRecordByID();
            this.loading = false; // Set loading to false after all data is loaded
        } catch (error) {
            console.error("Something went wrong during mounted:", error);
            this.isErr = true;
            this.errMsg = error;
        }
    }
};
</script>